// import * as Sentry from '@sentry/browser';

interface FormTextareaProps {
    textAreaWrappers: NodeListOf<HTMLDivElement>;
}

const CLASS_TEXTAREA_ERROR = 'form-textarea--error';

export const formTextarea = ({ textAreaWrappers }: FormTextareaProps) => {
    // Pro každý textarea wrapper
    textAreaWrappers.forEach((textAreaWrapper) => {
        const textarea = textAreaWrapper.querySelector('textarea');
        const charCounter = textAreaWrapper.querySelector('[data-counter-current]');

        if (!textarea || !charCounter) {
            // Sentry.captureException('formTextarea: textarea nebo charCounter nebyly nalezeny');
            return;
        }

        // Zjistit maximální délku textu
        const maxLength = Number(textarea.getAttribute('maxlength'));

        // Při psaní
        textarea.addEventListener('input', () => {
            // Aktualizovat počet znaků
            const remaining = maxLength - textarea.value.length;
            charCounter.textContent = `${remaining}`;

            // Pokud je text delší než maximální délka, označit error třídou
            if (textarea.value.length > maxLength) {
                textAreaWrapper.classList.add(CLASS_TEXTAREA_ERROR);
            } else {
                textAreaWrapper.classList.remove(CLASS_TEXTAREA_ERROR);
            }
        });
    });
};
